import {
  ShopActionTypes,
  FETCH_SHOP,
  FETCH_SHOP_TYPE,
  FETCH_SHOP_PRODUCT,
  LOADING_SHOP,
  ShopState,
  LOADING_PRODUCT_BUTTONS,
  FETCH_MY_ORDERS,
  SET_LOGIN,
  RESET_SHOP,
  FETCH_MENU,
} from "../actions/types";

const initialState: ShopState = {
  home_categories: [],
  products: [],
  product: [],
  typesSizes: [],
  variants: [],
  pathImages: [],
  isDisabledSite: false,
  isLoading: false,
  textPages: null,
  isLoadingProductButtons: false,
  myOrders: [],
  isLogued: false,
  lastPage: true,
  menuProducts: [],
};

export function shopReducer(
  state = initialState,
  action: ShopActionTypes,
): ShopState {
  switch (action.type) {
    case FETCH_SHOP:
      return {
        ...state,
        home_categories: action.payload.home_categories,
        isDisabledSite: action.payload.isDisabledSite,
        isLoading: false,
      };
    case RESET_SHOP:
      return {
        ...state,
        isLoading: true,
        products: initialState.products,
      };
    case FETCH_MENU:
      return {
        ...state,
        menuProducts: action.payload.products,
        textPages: {
          ...state.textPages,
          headerMessage: action.payload.headerMessage,
          termsAndConditions: action.payload.termsAndConditions,
          textHowtobuy: action.payload.textHowtobuy,
          textHowtopay: action.payload.textHowtopay,
          textSends: action.payload.textSends,
          textChanges: action.payload.textChanges,
        },
      };

    case FETCH_SHOP_TYPE:
      return {
        ...state,
        products:
          action.payload.page === 1
            ? action.payload.products
            : [...state.products, ...action.payload.products],
        isLoading: false,
        lastPage: action.payload.last_page,
      };

    case FETCH_SHOP_PRODUCT:
      return {
        ...state,
        product: {
          ...state.product,
          [action.payload.product.id]: action.payload.product,
        },
        typesSizes: {
          ...state.typesSizes,
          [action.payload.product.id]: action.payload.typesSizes,
        },
        variants: {
          ...state.variants,
          [action.payload.product.id]: action.payload.variants,
        },
        pathImages: {
          ...state.pathImages,
          [action.payload.product.id]: action.payload.pathImages,
        },
        isLoading: false,
        isLoadingProductButtons: false,
      };

    case LOADING_SHOP:
      return {
        ...state,
        isLoading: true,
      };
    case LOADING_PRODUCT_BUTTONS:
      return {
        ...state,
        isLoadingProductButtons: true,
      };
    case FETCH_MY_ORDERS:
      return {
        ...state,
        myOrders: action.payload.myOrders,
        isLoading: false,
      };
    case SET_LOGIN:
      return {
        ...state,
        isLogued: action.payload.isLogued,
      };
    default:
      return state;
  }
}
